import React from 'react';

import { IDescriptionContext } from './interfaces';

const DescriptionContext = React.createContext({
  stripEmpty: false,
} as IDescriptionContext);

export default DescriptionContext;
